import {
  LOGIN_SUCCESS,
  LOGOUT_RESPONSE,
  LOAD_AUTH,
} from '../constants'

// {isAuthenticated}
// The starting state sets authentication based on a token being in local storage.
// TODO: We would also want a util to check if the token is expired.
const initialState = {
  isAuthenticated: false,
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case LOAD_AUTH:
      return {
        ...action.auth,
        isAuthenticated: true,
      }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
